<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">


<!--sidebar-->
<ItemSidebar :name="$store.state.countries.country.name" 
></ItemSidebar>
<!--sidebar-->


<div class="col-12 md:col-10">
<div class="content_card_content">

<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'Certificatetype',

  data () {
    return {
      item:null,
      tabs: [
          {
              title: 'genel',
              icon: 'list',
              route:'general'
          },
          {
              title: 'sehirler',
              icon: 'map-marker',
              route: 'cities',
          }, 
      ],

    }
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
  	async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("country/"+this.$route.params.id)         
        this.$store.dispatch('countries/setCountry',this.item)  
        
    }
  }
};
</script>

<style lang="css">
  
</style>